import { InitialActionAllower, RouteToCallback } from '@creditsights/styleguide-web/components/DataView';
import { DataViewConfig, ExpandedViewConfig } from '@creditsights/styleguide-web';
import { MouseEvent } from 'react';
import classNames from 'classnames/bind';
import { ROUTES } from '../../../Base.constants';
import { ArticleTableRow } from '../../../models/ArticleTableRow';
import { CompaniesFormatter, DateRenderer, GhostLinkRenderer, TitleFormatter } from '../../formatters';
import { ContentTypeRenderer } from '../../formatters/ContentTypeRenderer';
import styles from './viewConfigs.module.scss';

const cx = classNames.bind(styles);

// const DEFAULT_COMPANY_COUNT = 3;
// const DEFAULT_TABLET_PORTRAIT_COMPANY_COUNT = 1;

const expandedConfig = (
  isTabletPortrait: boolean,
  routeToCallback: RouteToCallback,
  shouldAllowInitialAction: InitialActionAllower,
  isTypeShown: boolean
): ExpandedViewConfig => {
  const articleType = {
    dataKey: 'articleType',
    dataRenderer: ContentTypeRenderer,
    dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
  };
  const ghostLinkRenderer = {
    renderWithoutDataValue: true,
    dataRenderer: GhostLinkRenderer,
    dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
  };

  const subtitle = [
    {
      dataKey: 'publishDate',
      dataRenderer: DateRenderer,
      dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback, className: cx('date-renderer') },
    },
    {
      dataKey: 'companies',
      // TODO: Switch to TickersFormatter when Ticker data is fixed
      // dataRenderer: TickersFormatter({
      //   companyCount: isTabletPortrait ? DEFAULT_TABLET_PORTRAIT_COMPANY_COUNT : DEFAULT_COMPANY_COUNT,
      // }),
      dataRenderer: CompaniesFormatter(),
      dataViewItemConfiguration: {
        stopMouseUpPropagation: true,
        shouldAllowInitialAction,
        routeToCallback,
      },
    },
  ];
  return {
    title: {
      dataKey: 'content.title',
      dataRenderer: TitleFormatter,
      dataViewItemConfiguration: { shouldAllowInitialAction, routeToCallback },
    },
    subtitle: isTypeShown ? [ghostLinkRenderer, articleType, ...subtitle] : [ghostLinkRenderer, ...subtitle],
  };
};

export const getExpandedViewConfig = (
  isTabletPortrait: boolean,
  onPreviewableArticleClick?: (article: ArticleTableRow, event: MouseEvent<HTMLElement>) => void,
  isPreviewable?: boolean,
  isTypeShown = true
): DataViewConfig<ArticleTableRow> => {
  const shouldAllowInitialAction: InitialActionAllower = (row) => isPreviewable || !!row?.isDisabled;
  const routeToCallback: RouteToCallback = (articleId) => ROUTES.article(articleId);
  return {
    expandedViewConfig: expandedConfig(isTabletPortrait, routeToCallback, shouldAllowInitialAction, isTypeShown),
    clickable: true,
    onRowMouseUp: onPreviewableArticleClick,
  };
};
